<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <v-col cols="12">
        <AnalyticsData
          :selectedItem="selectedItem"
          :paginationDate="paginationDate"
        >
          <template
            v-slot="{ audit, loading, loadingChart, websites, auditsHistory }"
          >
            <div>
              <subtitle-component>
                {{ $t("message.common.report") }}
              </subtitle-component>
              <v-card class="pa-5">
                <ActionBar
                  v-if="websites.length > 0"
                  :sites="websites"
                  @selected="getSelected"
                >
                  <AuditDate
                    v-if="audit && audit.created_at"
                    :auditDate="audit.created_at"
                  />
                </ActionBar>
                <template v-if="audit">
                  <AuditResult :selectedItem="selectedItem" :audit="audit" />
                </template>
              </v-card>

              <subtitle-component class="mt-md-6 mb-0">
                {{ $t("message.common.details") }}
              </subtitle-component>

              <template v-if="audit && auditsHistory">
                <AuditSummary
                  :selectedItem="selectedItem"
                  :audit="audit"
                  :chartData="auditsHistory"
                  :loadingChart="loadingChart"
                  @paginationDate="paginationDate = $event"
                />
              </template>
              <template v-if="!websites.length > 0">
                <v-card>
                  <v-row
                    no-gutters
                    style="min-height: 600px;"
                    class="d-flex justify-center align-center"
                  >
                    <v-col cols="3" class="d-flex align-center flex-column">
                      <v-icon x-large color="primary" class="ma-3">web</v-icon>
                      <p class="text-center">
                        {{ $t("message.analytics.websites.noWebsitesAdded") }}
                      </p>
                      <v-btn color="primary" :to="{ name: 'profile-websites' }">
                        <v-icon small>icon-plus</v-icon>
                        {{ $t("message.analytics.websites.addWebsite") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
              <template v-if="websites.length > 0 && !audit">
                <v-card>
                  <v-row
                    no-gutters
                    style="min-height: 600px;"
                    class="d-flex justify-center align-center"
                  >
                    <v-col cols="3" class="d-flex align-center flex-column">
                      <v-icon x-large color="primary" class="ma-3"
                        >icon-search</v-icon
                      >
                      <p class="text-center">
                        {{
                          $t(
                            "message.analytics.websites.noAuditYetTryAgainLater"
                          )
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
              <SectionLoader :status="loading" :opacity="1" />
            </div>
          </template>
        </AnalyticsData>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ActionBar from "@/components/Analytics/ActionBar.vue";
import AuditResult from "@/components/Analytics/AuditResult.vue";
import AuditSummary from "@/components/Analytics/AuditSummary.vue";
import AuditDate from "@/components/Analytics/AuditDate.vue";
import AnalyticsData from "@/components/data/Analytics.js";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import ViewHeader from "@/components/ui/ViewHeader.vue";
import SubtitleComponent from "@/components/ui/Subtitle/Subtitle.component.vue";

import { mapState } from "vuex";

export default {
  name: "Analytics",
  components: {
    ActionBar,
    AuditResult,
    AuditSummary,
    AuditDate,
    AnalyticsData,
    SectionLoader,
    ViewHeader,
    SubtitleComponent
  },

  data() {
    return {
      viewTitle: this.$t("message.common.www_analytics"),
      paginationDate: {},
      selectedItem: {}
    };
  },

  methods: {
    getSelected(val) {
      this.selectedItem = val;
    }
  }
};
</script>

<style lang="scss" scoped></style>
